import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { updateUser } from 'common/api/user';
import Content from './Content';
import StrategyDomainContent from './strategyDomainContent';
import { isStrategyDomainUser } from '../applicationDomainHelper';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import QubitTermsAndConditions from './Qubit';

const propTypes = {
  currentUserId: PropTypes.number,
  isTermsAndConditionsAgreed: PropTypes.bool.isRequired,
};

const defaultProps = {
  currentUserId: null,
};

const TermsAndConditions = ({ currentUserId, isTermsAndConditionsAgreed }) => {
  const [isAgreed] = useState(isTermsAndConditionsAgreed);

  const hasAgreeTermsAndConditions = () => {
    updateUser({ id: currentUserId, is_terms_and_conditions_agreed: true }).then(() => {
      window.location.reload();
    });
  };

  const renderBackButton = (styleClass) => {
    const aTagClassName = `d-inline-flex btn btn-outline-primary btn-sm btn-pill my-2 ${styleClass}`;

    if (!currentUserId || (currentUserId && isAgreed)) {
      return (
        <div className="container">
          <a className={aTagClassName} href="/">
            <span className="material-icons-outlined tx-18 mr-1">arrow_back</span>
            Back
          </a>
        </div>
      );
    }

    return null;
  };

  const renderButton = () => {
    if (!currentUserId) return null;
    if (isAgreed) return null;

    return (
      <div className="container">
        <button
          type="button"
          className="btn btn-sm btn-primary mt-3 mb-10"
          onClick={() => hasAgreeTermsAndConditions()}
          disabled={isAgreed}
        >
          {isAgreed ? 'Agreed' : 'Agree'}
        </button>
      </div>
    );
  };

  const ContentComponent = () => {
    switch (true) {
      case ApplicationDomainUtility.isQubit:
        return <QubitTermsAndConditions />;
      case isStrategyDomainUser():
        return <StrategyDomainContent />;
      default:
        return <Content />;
    }
  };

  return (
    <>
      {renderBackButton('mb-5')}
      <ContentComponent />
      <div className="d-flex justify-content-between">{renderButton()}</div>
    </>
  );
};

TermsAndConditions.propTypes = propTypes;
TermsAndConditions.defaultProps = defaultProps;

export default TermsAndConditions;
